import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyL } from '#src/atoms/typography/index.tsx';
import { Img } from '#src/atoms/ui/Img/index.tsx';
import type { League } from '#src/components/landing/types.ts';
import { useConnectionContext } from '#src/contexts/connection/index.tsx';
import { useEvents } from '#src/lib/events/useEvents.ts';
import { glossary } from '#src/lib/glossary.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  background-image: var(--background);
  background-size: cover;
  background-position: center bottom;
  border-radius: 20px 20px 0 0;
  padding: var(--triple-unit);
  gap: var(--double-unit);
  @media (${laptopAndAbove}) {
    min-height: 900px;
    flex-direction: row;
    gap: calc(var(--unit) * 12);
  }
`;

const TextContainer = styled(Vertical)`
  align-items: flex-start;
  max-width: 450px;
`;

const TitleText = styled.h2`
  font-size: var(--fs-landing-title);
  line-height: 1;
  font-family: var(--brand-font);
  text-transform: uppercase;
`;

const StyledImgWrapper = styled.div`
  img {
    width: 100%;
    max-width: 532px;

    height: auto;
    object-fit: cover;
  }
`;

type Props = {
  assets: {
    background: string;
    lineup: string;
  };
  league: League;
  messages: {
    play: MessageDescriptor;
    playDescription: MessageDescriptor;
  };
  style?: CSSProperties;
};

export const Play = ({ assets, league, messages, style }: Props) => {
  const { signUp } = useConnectionContext();
  const track = useEvents();

  const onClick = () => {
    track('Click Landing Page Play', { clickSource: league });
    signUp();
  };
  return (
    <Wrapper
      style={
        {
          '--background': `image-set(url(${assets.background}))`,
          ...style,
        } as CSSProperties
      }
    >
      <StyledImgWrapper>
        <picture>
          <Img src={assets.lineup} alt="" />
        </picture>
      </StyledImgWrapper>
      <TextContainer gap={5}>
        <Vertical gap={2}>
          <TitleText>
            <FormattedMessage {...messages.play} />
          </TitleText>
          <BodyL>
            <FormattedMessage {...messages.playDescription} />
          </BodyL>
        </Vertical>
        <Button color="secondary" size="large" onClick={onClick}>
          <FormattedMessage {...glossary.playNow} />
        </Button>
      </TextContainer>
    </Wrapper>
  );
};
